import { ADD_KEYBOARD_EVENTS, DEL_KEYBOARD_EVENTS } from '../types';
import { Subject } from 'rxjs';

const usedKeys = [];

const defaultState = {
  subject: new Subject(),
  close: new Subject(),
};

const getKeyCode = (ev) => {
  const { code, ctrlKey, shiftKey, altKey } = ev;
  let key = ctrlKey ? 'Ctrl+' : '';
  if (shiftKey) key += 'Shift+';
  if (altKey) key += 'Alt+';
  key += code;
  return key;
}

const keyDownListener = (ev) => {
  const keyCode = getKeyCode(ev);
  if (usedKeys.indexOf(keyCode) !== -1) ev.preventDefault();
}

export default function reducer(state = defaultState, action) {
  const keyUpListener = (ev) => {
    const keyCode = getKeyCode(ev);
    if (keyCode === 'Escape') {
      state.close.next(); // todo: windows open handler
    } else {
      state.subject.next(keyCode);
    }
  }
  switch (action.type) {
    case ADD_KEYBOARD_EVENTS:
      document.addEventListener('keydown', keyDownListener);
      document.addEventListener('keyup', keyUpListener);
      return state;
    case DEL_KEYBOARD_EVENTS:
      document.removeEventListener('keydown', keyDownListener);
      document.removeEventListener('keyup', keyUpListener);
      return state;
    default:
      return state;
  }
}